let flexible = function (options) {
  let designWidth = options;
  //忽略旋转导致的尺寸变化
  let ignoreOrientation = true;
  if (dsf.isObject(options)) {
    designWidth = options.designWidth;
    ignoreOrientation = options.ignoreOrientation;
  } else {
    designWidth = options;
  }
  var docWidth;

  function getDocWidth() {
    if (dsf.isUnDef(designWidth)) {
      /* 设计图文档宽度 */
      //如果是pad
      if (dsf.client.pad()) {
        //pad设计稿为(纵向)1600*2500
        docWidth = 1600;
      }
      //如果是手机
      else {
        //手机设计稿为(纵向)375*667
        docWidth = 750;
      }
    } else {
      docWidth = designWidth;
    }
  }

  getDocWidth();

  var minPx = 320;
  var baseFontSize = 100;
  var doc = window.document,
    docEl = doc.documentElement,
    resizeEvt = "orientationchange" in window ? "orientationchange" : "resize";
  var recalc = function () {
    // getDocWidth();
    let scrollWidth = window.innerWidth; //window?.screen?.width;
    let scrollHeight = window.innerHeight; //window?.screen?.heigh;
    //如果是平台提供的预览、app应用管理页面进入
    // if (window?.frameElement?.name == "appDemo") {
    //   scrollWidth = window.innerWidth;
    //   scrollHeight = window.innerHeight;
    // }

    var clientRealSize = 0;
    //如果忽略了旋转则判断如果横向则取屏幕高度作为宽度
    if (ignoreOrientation && dsf.isDef(window.orientation)) {
      if (window.orientation === 180 || window.orientation === 0) {
        clientRealSize = scrollWidth || window.innerWidth;
      } else if (window.orientation === 90 || window.orientation === -90) {
        clientRealSize = scrollHeight || window.innerHeight;
      }
    } else {
      clientRealSize = scrollWidth || window.innerWidth;
    }

    /* 
    8.55：小于320px，
    11.2：大于420px
    */
    // docEl.style.fontSize = Math.max(Math.min(20 * (clientWidth / docWidth), 20), 8.55) * 5 + 'px';
    // return refreshRem;
    // 如果比例大于设计稿尺寸不再放大
    if (clientRealSize >= docWidth) {
      docEl.style.fontSize = baseFontSize + "px";
    } else if (clientRealSize <= minPx) {
      docEl.style.fontSize = baseFontSize * (minPx / docWidth) + "px";
    } else {
      docEl.style.fontSize = baseFontSize * (clientRealSize / docWidth) + "px";
    }
  };

  /* 添加倍屏标识，安卓为1 */
  docEl.setAttribute("data-dpr", window.navigator.appVersion.match(/iphone/gi) ? window.devicePixelRatio : 1);
  if (dsf.client.info.os == "iOS") {
    /* 添加IOS标识 */
    doc.documentElement.classList.add("ios");
    /* IOS8以上给html添加hairline样式，以便特殊处理 */
    if (parseInt(window.navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/)[1], 10) >= 8) {
      doc.documentElement.classList.add("hairline");
    }
  }

  if (!doc.addEventListener) return;
  window.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener("DOMContentLoaded", recalc, false);
};

export default flexible;
